import { render, staticRenderFns } from "./ApplicationEntry.vue?vue&type=template&id=1527cf99"
import script from "./ApplicationEntry.vue?vue&type=script&lang=js"
export * from "./ApplicationEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports